import fetchAPI from '../../../utils/fetchAPI';
import { TBiddingClient } from 'types/TBidding';

type TParams = {
  itemId: string;
  xsrfToken: string;
};

export default async function getBids({ itemId, xsrfToken }: TParams): Promise<TBiddingClient> {
  try {
    return await fetchAPI({
      url: `/v/api/bids/${itemId}`,
      method: 'GET',
      xsrfToken,
    });
  } catch (e) {
    return {};
  }
}
